import React, { useState, useEffect } from "react";
import { ApiService, ImgUrl } from "../services";
import { useSnackbar } from "react-simple-snackbar";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import FormikControl from "../formikComponents/formikControl";
import GImageEditor from "../gComponents/gImageEditor";
import GButton from "../gComponents/gButton";
import useDataFctory from "../useDataFactory";
import Modal from "react-modal";
import LocalizationForm from "../forms/localizationForm";

export default function ProductCategoryForm(props) {
  console.log(props);
  const [isBtnDisabled, setIsBtnDisabled] = useState(false);
  const { data: categoriesList } = useDataFctory("product/group", false, {
    store_id: props.storeId,
  });
  const [openSnackbar] = useSnackbar();
  const [localizationsArray, setLocalizationsArray] = useState(
    props.data?.localizations || []
  );
  const [localizationVisible, setLocalizationVisible] = useState(false);
  const initialValues = {
    title: !props.isEmpty ? props.data.title : "",
    photo: !props.isEmpty && props.categoryId ? props.data.photo : "",
    thumb_photo:
      !props.isEmpty && props.categoryId ? props.data.thumb_photo : "",
    // description: !props.isEmpty ? props.data.description : "",
    store_id: props.storeId,
    parent_id: props.categoryId ? props.categoryId : "",
    index: !props.isEmpty ? props.data.index : "",
  };

  const onSubmit = (values) => {
    setIsBtnDisabled(true);
    values.localizations = localizationsArray;
    console.log(values);
    var hitMethod = !props.isEmpty ? "PUT" : "POST";
    var hitUrl = !props.isEmpty
      ? "product/categories/" + props.data.id
      : "product/categories";
    ApiService({ method: hitMethod, route: hitUrl, body: values }).then(
      (response) => {
        console.log(response.data);
        if (response.data.status_code === 1) {
          props.setCatFormvisible(false);
          props.onSubmit();
        }
        setIsBtnDisabled(false);
        openSnackbar(response.data.message);
        return;
      }
    );
  };

  const validationSchema = Yup.object({
    title: Yup.string().required("Required"),
    parent_id: props.categoryId ? Yup.string().required("Required") : "",
    // description: Yup.string().required("Required")
  });

  if (props.catFormvisible === false) {
    return null;
  }
  return (
    <>
      <div className="modal-header">
        {!props.isEmpty ? "Edit" : "Add"}{" "}
        {!props.categoryId ? "Category" : "Subcategory"}
      </div>
      <div className="modal-body">
        <Formik
          initialValues={initialValues}
          onSubmit={onSubmit}
          validationSchema={validationSchema}
        >
          {({ values, setFieldValue }) => (
            <Form>
              {props.categoryId ? (
                <GImageEditor
                  onSubmit={(newValue, id, thumb_val) => {
                    values.photo = newValue;
                    values.thumb_photo = thumb_val;
                  }}
                  id="thumb_photo"
                  image={
                    values.photo ? ImgUrl("category") + "/" + values.photo : ""
                  }
                  type="category"
                  style={{ height: "160px", paddingTop: "60px" }}
                  divstyle={{ margin: "0 auto", display: "block" }}
                />
              ) : (
                ""
              )}
              <br />

              <FormikControl
                control="input"
                type="text"
                label="Title"
                name="title"
              />

              {/* <FormikControl
                  control="input"
                  as="textarea"
                  label="Description"
                  name="description"
                /> */}

              {props.categoryId ? (
                <FormikControl
                  control="select"
                  as="select"
                  label="Category"
                  name="parent_id"
                  options={categoriesList}
                  key_title="title"
                  key_value="id"
                />
              ) : (
                ""
              )}

              <FormikControl
                control="input"
                type="text"
                label="Sort Index"
                name="index"
                onChange={(event) => {
                  const re = /^[0-9\b]+$/;
                  if (event.target.value && !re.test(event.target.value)) {
                    return;
                  } else {
                    setFieldValue("index", event.target.value);
                  }
                }}
              />

              {props.settings?.locales &&
                props.settings?.locales.length > 0 && (
                  <div style={{ margin: "15px 15px 0" }}>
                    <label>Localizations</label>

                    {localizationsArray.length > 0 ? (
                      <GButton
                        variant="linkable"
                        onClick={() => setLocalizationVisible(true)}
                      >
                        {localizationsArray.length} Localizations added
                      </GButton>
                    ) : (
                      <GButton
                        variant="linkable"
                        children="+ Add Localization"
                        onClick={() => setLocalizationVisible(true)}
                      />
                    )}
                  </div>
                )}
              <br />
              <GButton
                type="submit"
                disabled={isBtnDisabled}
                variant="condensed"
                children={!props.isEmpty ? "Update" : "Create"}
                style={{ width: "calc(100% - 30px)", margin: "0 15px" }}
              />
            </Form>
          )}
        </Formik>
      </div>

      <Modal
        isOpen={localizationVisible}
        className="modal modalRight"
        overlayClassName="modal-overlay"
        onRequestClose={() => setLocalizationVisible(false)}
        style={{
          content: {
            width: "600px",
          },
        }}
        contentLabel="Localization Form Modal"
      >
        <LocalizationForm
          localizationVisible={localizationVisible}
          setLocalizationVisible={setLocalizationVisible}
          data={localizationsArray}
          onSubmit={(data) => {
            setLocalizationsArray([...data]);
          }}
          keyArray={[{ title: "Title", value: "title" }]}
          variables={[]}
          onLocalizationRemove={(ind) => {
            props.onLocalizationRemove(ind);
          }}
          onLocalizationUpdate={(ind, data) => {
            props.onLocalizationUpdate(ind, data);
          }}
        />
      </Modal>
    </>
  );
}
